const pricingCalculators = document.querySelectorAll('[data-pricing-calculator]')

const tiers = [
    { min: 50, max: 200, price: 155 },
    { min: 201, max: 400, price: 155 },
    { min: 401, max: 600, price: 150 },
    { min: 601, max: 800, price: 150 },
    { min: 801, max: 1000, price: 150 },
    { min: 1001, max: 1200, price: 145 },
    { min: 1201, max: 2000, price: 145 },
    { min: 2001, max: 2500, price: 140 },
    { min: 2501, max: 3000, price: 135 },
    { min: 3001, max: 5000, price: 130 },
    { min: 5001, max: Infinity, price: null },
]

function getPrice(fte) {
    const tier = tiers.find(t => fte >= t.min && fte <= t.max)
    return tier ? tier.price : null
}

function fmt(n) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n)
}

function pushEvent(eventName) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName })
}

pricingCalculators.forEach(calculator => {
    const fteInput = calculator.querySelector('[data-fte-input]')
    const estimateInput = calculator.querySelector('[data-estimate-output]')
    const ctaBtn = calculator.querySelector('[data-cta-btn]')
    if (!fteInput) return

    const subscriptionFormUrl = 'https://iste.ascd.org/learning-academy-subscriptions-interest-form'

    let fteEngagementTracked = false

    function clearEstimate() {
        estimateInput.value = ''
        ctaBtn.classList.add('is-disabled')
        ctaBtn.setAttribute('aria-disabled', 'true')
        ctaBtn.href = subscriptionFormUrl
    }

    function updateCtaUrl(fte) {
        let url =
            ctaBtn.href.split('?')[0] +
            (ctaBtn.href.includes('?')
                ? '?' +
                  ctaBtn.href
                      .split('?')[1]
                      .split('&')
                      .filter(p => !p.startsWith('fte='))
                      .join('&')
                : '')
        if (fte && !isNaN(fte)) {
            const separator = url.includes('?') ? '&' : '?'
            url += `${separator}fte=${fte}`
        }
        ctaBtn.href = url
    }

    fteInput.addEventListener('input', function() {
        if (!fteEngagementTracked) {
            fteEngagementTracked = true
            pushEvent('pricing_calculator')
        }

        const fte = parseInt(this.value, 10)

        if (!this.value || isNaN(fte) || fte < 1) {
            clearEstimate()
            return
        }

        // Under 50 licenses: no CTA, prompt for the minimum
        if (fte < 50) {
            clearEstimate()
            estimateInput.value = 'Please enter 50 or more'
            return
        }

        const price = getPrice(fte)
        if (price === null) {
            estimateInput.value = 'Contact Sales Team'
        } else {
            const lower = fte * price
            const upper = Math.round(fte * price * 1.1)
            estimateInput.value = `${fmt(lower)} - ${fmt(upper)}`
        }

        ctaBtn.classList.remove('is-disabled')
        ctaBtn.removeAttribute('aria-disabled')
        updateCtaUrl(fte)
    })

    if (ctaBtn) {
        ctaBtn.addEventListener('click', function(e) {
            // Also blocks keyboard activation; CSS pointer-events only stops mouse
            if (this.classList.contains('is-disabled')) return e.preventDefault()
            pushEvent('contact_sales')
        })
    }
})
